import { composeAction } from '@gef-ui/redux-common/utils';
import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import setInPath from "@gef-ui/utils/setInPath";
import { handleActions } from '@gef-ui/utils/fsaActions';
import __ from "ramda/es/__";
import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import dec from "ramda/es/dec";
import ifElse from "ramda/es/ifElse";
import inc from "ramda/es/inc";
import isNil from "ramda/es/isNil";
import lensProp from "ramda/es/lensProp";
import set from "ramda/es/set";
import view from "ramda/es/view";
import when from "ramda/es/when";
import dotPath from "ramda-extension/es/dotPath";
import mapKeys from "ramda-extension/es/mapKeys";
import { formActions } from '../../constants';
const stepLens = lensProp('step');
const replaceData = {
    next (_state, action) {
        const { formData } = action.payload;
        return Object.assign({}, formData);
    }
};
const changeStep = (increment)=>({
        next (state) {
            const newStep = compose(ifElse(()=>increment, inc, dec), view(stepLens))(state);
            return set(stepLens, newStep, state);
        }
    });
const setStep = {
    next (state, action) {
        const { step } = action.payload;
        return set(stepLens, step, state);
    }
};
const resetForm = {
    next () {
        // just for clarification, redux return default state if get undefined
        return undefined;
    }
};
const updateFieldReducer = curry((state, { payload })=>payload.temp ? state : setInPath(payload.path, payload.value, state));
const formReducersMap = {
    [formActions.REPLACE_DATA]: replaceData,
    [formActions.INCREMENT_STEP]: changeStep(true),
    [formActions.DECREMENT_STEP]: changeStep(false),
    [formActions.RESET_FORM]: resetForm,
    [formActions.SET_STEP]: setStep,
    [formActions.UPDATE_FIELD_VALUE]: updateFieldReducer,
    [formActions.DEFAULT_FIELD_VALUE]: (state, { payload })=>when(compose(isNil, dotPath(payload.path)), updateFieldReducer(__, {
            payload
        }))(state)
};
export default memoizeWithAllArguments((formName, defaultState = {})=>handleActions(mapKeys(composeAction(formName), formReducersMap), defaultState));
